import { Context, createContext } from 'react';

/** @type {Context<Array<{backgroundUrl: string, iconUrl: string, altText: string, actionItem: Element, headerText: string, subText: string}>>} */
export const PromosContext = createContext(undefined);
